import type {
  CreateOrUpdateSitePageSnapshotBody,
  SitePageSnapshot,
} from "schemas/sitePageSnapshots";
import type { RequestFn } from "./request";

export function createSitePageSnapshotsClient({
  request,
}: {
  request: RequestFn;
}) {
  return {
    createOrUpdate: ({
      siteId,
      ...body
    }: { siteId: string } & CreateOrUpdateSitePageSnapshotBody) => {
      return request<SitePageSnapshot>({
        method: "POST",
        path: `/api/v1/sites/${encodeURIComponent(siteId)}/page-snapshots`,
        body,
      });
    },
    find: ({ siteId }: { siteId: string }) => {
      return request<SitePageSnapshot[]>({
        method: "GET",
        path: `/api/v1/sites/${encodeURIComponent(siteId)}/page-snapshots`,
      });
    },
  };
}
